<script lang="ts">
import type { CreateElement } from "vue";
import Vue from "vue";
export default Vue.extend({
  name: "BmColumnHint",
  props: {
    activeField: {
      type: Boolean,
      default: false,
    },
    empty: {
      type: Boolean,
      default: false,
    },
  },
  render(createElement: CreateElement) {
    if (!this.empty) {
      return createElement(
        "div",
        { class: { "bm-more": this.activeField } },
        // eslint-disable-next-line vue/require-slots-as-functions
        [this.$slots.default]
      );
    } else {
      return undefined;
    }
  },
});
</script>

<style scoped lang="sass">
@import "src/sass/colours"

div.bm-more
  height: auto
  margin-bottom: 2em
  display: block

div
  position: relative
  border: 1px solid $bm-color-borders
  display: none
  padding: 6px
  margin-left: 9px
  border-radius: 5px
  background: $bm-color-background01
  min-height: 40px

/* Speach Bubble arrow */
div:before
  content: ''
  position: absolute
  left: 0
  top: 18px
  width: 0
  height: 0
  border: 18px solid transparent
  border-right-color: $bm-color-borders
  border-left: 0
  border-bottom: 0
  margin-left: -18px

div:after
  content: ''
  position: absolute
  left: 0
  top: 17px
  width: 0
  height: 0
  border: 18px solid transparent
  border-right-color: $bm-color-background01
  border-left: 0
  border-bottom: 0
  margin-left: -16px


a
  position: absolute
  right: 0
  bottom: 2px
  background-image: linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,1) 40%)
  padding-left: 30px
</style>
